export const subprojectEndpoints = {
  BUILDING_DETAIL: (orgId: string, subprojectId: string) =>
    `/api/organizations/${orgId}/subprojects/building/${subprojectId}/`,
};
